import { FC } from 'react';
import AlertBanner from 'modules/maya/components/AlertBanner/AlertBanner';
import Dashboard from 'modules/maya/components/Dashboard/Dashboard';
import MayaLayout from 'modules/maya/components/MayaLayout';

const Maya: FC = () => {
  return (
    <MayaLayout>
      <AlertBanner />
      <Dashboard />
    </MayaLayout>
  );
};

export default Maya;
